import { FC, Fragment } from 'react';
import { Error, WrappedQuery } from '.';
import { Chart } from '../serviceProvider';
import { queryLookup } from '../../utils/charts';
import { OperationVariables, QueryResult } from '@apollo/client';

interface ChartProps {
  query?: string;
  type: string;
  variables?: string;

  data?: object;
  formatData: string;
  width?: number;
  height?: number;
  legend?: string;
  options?: string;
}

const DashboardChart: FC<ChartProps> = ({ query, type, variables, formatData, ...rest }) => {
  return (
    <Fragment>
      {query && (
        <WrappedQuery query={queryLookup[query]} variables={variables && JSON.parse(variables)} overrideStates={true}>
          {({ loading, error, data }: QueryResult<any, OperationVariables>) => {
            if (data) {
              return <Chart queryData={data} formatData={formatData} type={type} {...rest} />;
            }

            if (loading) return null;

            if (error) return <Error />;

            return null;
          }}
        </WrappedQuery>
      )}
    </Fragment>
  );
};

export default DashboardChart;
